import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { MainButton } from '../../../../../../gui/input/MainButton';
import { GridRow } from '../../../../../../gui/layout/GridRow';
import { FlexContainer, MainContent } from '../Style';


import styled from 'styled-components';
import withActionPageLoader from '../../../../../../hoc/withActionPageLoader';
import { fetchMessages, sendMessage, loadProfileImage } from './actions/messageActions.js';
import {Loader} from "../../../../../../../App/AppComponents/Loader"

const StyledMessages = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 70%;
  height: 39rem;
  min-height: 48vh;

  margin: 2rem !important;
  margin-bottom: 0;
  margin-right: auto;
  background: #ffffff;
  box-shadow: 5px 3px 15px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding-bottom: 2rem;
  /* transform: matrix(1, 0, 0, -1, 0, 0); */

.fa-circle-user{
  font-size: 5rem;
  color: ${props=>props.theme.colors.primary};
}

  .chat-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 0 4rem;

    border-bottom: 1px solid #dddddd;
    min-height: 15vh;

    img {
      width: 64px;
      height: 64px;
      border-radius: 50px;
      object-fit: cover;
      object-position: top;
    }

    h3 {
      font-weight: bold;
      margin-left: 2rem;
    }
  }

  .chat-main-box {
    padding: 0 4rem;
    overflow: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */


    .message-written-by{
      width: fit-content;
      font-size: 1.3rem;
      color: grey;
      transform: translateY(0.5rem);
      }


    .chat-message {
      position: relative;
      width: fit-content;
      background: #f1f1f1;
      padding: 1rem 2rem;
      padding-right: 4rem;
      border-radius: 18px;
      font-size: 1.4rem;

      .timestamp {
        /*display: none;*/
        width: max-content;
        flex-wrap: nowrap;
        color: #a5a5a5;
        position: absolute;
        top: 130%;
        left: 0;
        font-size: 1.15rem;
      }

      &.not-our-message {
        /*&:last-child {
          background: #000;
          .timestamp {
            display: flex;
            left: 0;
            right: auto;
            flex-wrap: nowrap;
          }
        }*/
      } 




      &.our-message {
        background: #418eeb;
        color: white;
        margin-left: auto;

        &:last-child {
          border-radius: 18px 18px 0px 18px;
          margin-bottom: 4rem;

          .timestamp {
            left: auto;
            right: 0;
            display: flex;
            flex-wrap: nowrap;
          }
        }
      }

    }
  }
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.8rem 1rem;
  }

  .chat-input-box {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #a5a5a5;
    border-radius: 12px;
    padding: 1rem 2rem;
    /* margin-top: 4rem; */
    padding: 0;
    width: 90%;
    margin: auto;
    margin-bottom: 0;
    padding: 1rem 2rem;

    input {
      border: none;
      width: 80%;
      /* height: 5rem; */

      &:focus,
      &:active {
        outline: none;
      }

      &::placeholder {
        color: #a5a5a5;
      }
    }

    svg {
      &.attachment {
        margin-right: 2rem;
      }
      &.send {
        margin-left: 1rem;
      }
    }
  }
`;

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const formatDate = (inputDate) => {
  let date = new Date(inputDate);
  let half = 'AM';
  let hours = date.getHours();
  if (hours === 0) {
    hours = 12;
  } else if (hours === 12) {
    half = 'PM';
  } else if (hours > 12) {
    hours -= 12;
    half = 'PM';
  }

  return hours.toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ' ' + half;
  // return date.getDate().toString().padStart(2, '0') + ' ' + months[date.getMonth()] + ' ' + date.getFullYear() + ', ' + hours.toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ' ' + half;
};

export const Messages = withActionPageLoader(fetchMessages, ({ caseData, loadedPageData, setUnreadCount, fromToken }) => {
  const authId = useSelector((state) => fromToken ? caseData._id : state.auth._id);
  const [messageList, setMessageList] = useState([]);
  const [caseHandlerProfileImage, setCaseHandlerProfileImage] = useState(null)
  const messageInput = useRef();
  const firstLoad = useRef(true);

  const onSendMessage = async () => {
    let messageToSend = messageInput.current.value.trim();
    messageInput.current.value = '';
    if (messageToSend !== '') {
      let newMessageList = [...messageList];
      let lastIndex = newMessageList.length - 1;
      if (lastIndex >= 0 && newMessageList[lastIndex].isMe) {
        newMessageList[lastIndex].dateTime = null;
      }
      newMessageList.push({ isMe: true, text: messageToSend, dateTime: formatDate(Date.now()) });

      setMessageList(newMessageList);

      try {
        await sendMessage({ message: messageToSend, caseId: caseData._id, fromToken });
      } catch (err) {
        console.log(err);
        newMessageList.pop();
        setMessageList(newMessageList);
      }
    }
  };

  const scrollToBottom = () => {
    let timestamps = document.getElementsByClassName("timestamp")
    if(timestamps.length > 0)
    {
      timestamps[timestamps.length-1].scrollIntoView(false)
      return true
    }
    else
    {
      return false
    }
  }

  const onKeyDownHandler = e => {
    if (e.keyCode === 13) {
      // this.sendMessage();
      onSendMessage()
    }
  };


  useEffect(() => {
    if (loadedPageData) {
      let newMessageList = [];
      let prevId = 0;
      let message = null;
      for (let i = 0; i < loadedPageData.messages.length; i++) {
        message = loadedPageData.messages[i];

        newMessageList.push({
          isMe: authId === message.userId,
          text: message.text,
          dateTime: i + 1 >= loadedPageData.messages.length || message.userId !== loadedPageData.messages[i + 1].userId ? formatDate(message.dateTime) : null,
          writtenBy: message.userId !== prevId ? message.writtenBy : null,
          unixTime: message.unixTime
        });

        prevId = message.userId;
      }

      newMessageList.sort((a,b) => a.unixTime - b.unixTime);

      setMessageList(newMessageList);
      if(setUnreadCount){
      setUnreadCount(0);
      } else{
        return null
    }
    }
  }, [loadedPageData]);


  useEffect(() => {
    if(firstLoad.current && messageList.length > 0)
    {
      firstLoad.current = false
      setTimeout(() => {
        if(!scrollToBottom())
        {
          setTimeout(() => {
            if(!scrollToBottom())
            {
              setTimeout(() => {
                if(!scrollToBottom())
                {
                  setTimeout(() => {
                    scrollToBottom()
                  },160)
                }
              },80)
            }
          }, 40)
        }
      }, 20)
    }
  }, [messageList])

  const onLoadProfileImage = async () => {
    if(loadedPageData.handlerId)
    {
      let image = await loadProfileImage(loadedPageData.handlerId)
      if(image)
      {
        setCaseHandlerProfileImage(image)
      }
    }
  }

  useEffect(() => {
    onLoadProfileImage()
  },[])

  return (
    <MainContent>
      <StyledMessages>
        <div className="chat-header">
          {!caseHandlerProfileImage && <i className="fa-solid fa-circle-user"></i>}
          {caseHandlerProfileImage && <img width={40} height={40} style={{borderRadius: "50%"}} src={caseHandlerProfileImage} />}
          <h3>{loadedPageData?.handler}</h3>
        </div>
        <div className="chat-main-box">
          {/*<p className='chat-message'>Hello John!</p>
          <p className='chat-message'>
            Can you arrange schedule for next meeting?
            <span className='timestamp'>12:45 PM</span>
          </p>
          <p className='chat-message our-message'>Hello John!</p>
          <p className='chat-message our-message'>
            Can you arrange schedule for next meeting?
            <span className='timestamp'>12:45 PM</span>
          </p>*/}
          {messageList.map((message, index) => (
            <>
            {(message.writtenBy && !message.isMe) && <div className="message-written-by">{message.writtenBy}</div>}
            <p key={'message_' + index} className={`chat-message ${message.isMe ? 'our-message' : 'not-our-message'}`}>
              {message.text}
              {message.dateTime ? <span className="timestamp">{message.dateTime}</span> : <></>}
            </p>
            </>
          ))}
        </div>
        <div className="chat-input-box">
          <input type="text" ref={messageInput} onKeyDown={(e)=>onKeyDownHandler(e)} placeholder="Write your message..." />
          {/* <svg className="attachment" width="24" height="29" viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.32408 28.2C5.08996 28.1973 3.88427 27.8293 2.859 27.1423C1.83373 26.4554 1.03478 25.4803 0.562871 24.3399C0.0909608 23.1996 -0.032785 21.9451 0.207233 20.7345C0.447251 19.524 1.04029 18.4116 1.91158 17.5375L12.5116 6.92503C12.8604 6.57621 13.2745 6.29951 13.7303 6.11072C14.186 5.92194 14.6745 5.82478 15.1678 5.82478C15.6611 5.82478 16.1496 5.92194 16.6054 6.11072C17.0611 6.29951 17.4753 6.57621 17.8241 6.92503C18.1729 7.27386 18.4496 7.68797 18.6384 8.14373C18.8272 8.59949 18.9243 9.08797 18.9243 9.58128C18.9243 10.0746 18.8272 10.5631 18.6384 11.0188C18.4496 11.4746 18.1729 11.8887 17.8241 12.2375L7.21158 22.8375C7.09953 22.9684 6.96163 23.0747 6.80655 23.1497C6.65147 23.2247 6.48255 23.2669 6.3104 23.2735C6.13825 23.2802 5.96659 23.2512 5.80618 23.1883C5.64577 23.1255 5.50009 23.0302 5.37827 22.9083C5.25645 22.7865 5.16113 22.6408 5.09829 22.4804C5.03544 22.32 5.00644 22.1484 5.01309 21.9762C5.01974 21.8041 5.0619 21.6352 5.13693 21.4801C5.21196 21.325 5.31823 21.1871 5.44908 21.075L16.0491 10.4625C16.2539 10.2234 16.3609 9.91581 16.3487 9.60122C16.3366 9.28662 16.2062 8.9882 15.9835 8.76558C15.7609 8.54296 15.4625 8.41254 15.1479 8.40039C14.8333 8.38824 14.5257 8.49525 14.2866 8.70003L3.67408 19.3C2.9696 20.0045 2.57383 20.96 2.57383 21.9563C2.57383 22.9526 2.9696 23.9081 3.67408 24.6125C4.37857 25.317 5.33405 25.7128 6.33033 25.7128C7.32662 25.7128 8.2821 25.317 8.98658 24.6125L19.5866 14C20.7251 12.8213 21.355 11.2425 21.3408 9.60378C21.3266 7.96504 20.6693 6.39747 19.5105 5.23867C18.3517 4.07986 16.7841 3.42256 15.1453 3.40832C13.5066 3.39408 11.9278 4.02404 10.7491 5.16253L4.56158 11.4125C4.32738 11.6453 4.01057 11.776 3.68034 11.776C3.3501 11.776 3.03329 11.6453 2.79909 11.4125C2.68192 11.2963 2.58893 11.1581 2.52547 11.0058C2.46201 10.8534 2.42934 10.69 2.42934 10.525C2.42934 10.36 2.46201 10.1966 2.52547 10.0443C2.58893 9.89199 2.68192 9.75374 2.79909 9.63753L8.98658 3.38753C10.6276 1.7465 12.8533 0.824585 15.1741 0.824585C17.4948 0.824585 19.7206 1.7465 21.3616 3.38753C23.0026 5.02856 23.9245 7.25427 23.9245 9.57503C23.9245 11.8958 23.0026 14.1215 21.3616 15.7625L10.7491 26.375C10.1676 26.9551 9.47749 27.4148 8.71822 27.7279C7.95894 28.0411 7.1454 28.2015 6.32408 28.2Z"
              fill="#A5A5A5"
            />
          </svg> */}
          <MainButton onClick={onSendMessage}>
            Send{' '}
            <svg className="send" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.97871 11.0125L13.0009 7.00002L8.98839 14.0222C8.91929 14.1431 8.88523 14.2809 8.89003 14.4201C8.89482 14.5593 8.93828 14.6944 9.01554 14.8103L12.1505 19.5128C12.2284 19.6296 12.3375 19.7222 12.4654 19.7801C12.5934 19.838 12.7349 19.8588 12.8741 19.8401C13.0133 19.8215 13.1444 19.7642 13.2526 19.6747C13.3608 19.5852 13.4417 19.4672 13.4861 19.334L19.4209 1.52877C19.465 1.39663 19.4714 1.25482 19.4394 1.11924C19.4074 0.983663 19.3382 0.859675 19.2397 0.761174C19.1412 0.662673 19.0173 0.593551 18.8817 0.561555C18.7461 0.52956 18.6043 0.535955 18.4721 0.580025L0.66714 6.515C0.533935 6.5594 0.415868 6.6403 0.326375 6.74849C0.236883 6.85669 0.17956 6.98783 0.160929 7.127C0.142298 7.26617 0.163108 7.40777 0.220991 7.5357C0.278873 7.66362 0.371504 7.77273 0.48834 7.8506L5.19084 10.9856C5.30672 11.0628 5.4418 11.1062 5.58095 11.1109C5.7201 11.1157 5.85783 11.0816 5.97871 11.0125Z"
                fill="white"
              />
            </svg>
          </MainButton>
        </div>
      </StyledMessages>
    </MainContent>
  );
});
